export default __webpack_public_path__ + "static/media/nguyetkhong.e2bf72b5.png";